import { render, staticRenderFns } from "./PortfolioPageItemDetails.vue?vue&type=template&id=50ab06a8&scoped=true"
import script from "./PortfolioPageItemDetails.vue?vue&type=script&lang=ts"
export * from "./PortfolioPageItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioPageItemDetails.vue?vue&type=style&index=0&id=50ab06a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab06a8",
  null
  
)

export default component.exports